const STORAGE_PREFIXES = [ 'chat-messenger-', 'GSA:' ];
const CHAT_TENANT_PREFIX = 'GSA-t-';

export const migrateToTenantStorage = (tenantKey: string): void => {
  if (typeof window === 'undefined') return;

  const keysToMigrate: Array<{ key: string; prefix: string }> = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || key.startsWith(CHAT_TENANT_PREFIX)) continue;

    const matchedPrefix = STORAGE_PREFIXES.find(prefix => key.startsWith(prefix));
    if (matchedPrefix) {
      keysToMigrate.push({ key, prefix: matchedPrefix });
    }
  }

  keysToMigrate.forEach(({ key, prefix }) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      const suffix = key.slice(prefix.length);
      const tenantKeyed = `${CHAT_TENANT_PREFIX}${tenantKey}-${prefix}${suffix}`;
      localStorage.setItem(tenantKeyed, value);
      localStorage.removeItem(key);
    }
  });
};

export const restoreFromTenantStorage = (tenantKey: string): void => {
  if (typeof window === 'undefined') return;

  const prefix = `${CHAT_TENANT_PREFIX}${tenantKey}-`;
  const keysToRestore: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(prefix)) {
      keysToRestore.push(key);
    }
  }

  keysToRestore.forEach(key => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      const suffix = key.slice(prefix.length);
      const matchedPrefix = STORAGE_PREFIXES.find(p => suffix.startsWith(p));
      if (matchedPrefix) {
        localStorage.setItem(suffix, value);
        localStorage.removeItem(key);
      }
    }
  });
};
